/**
 * @param {{ key?: string, value?: string }} item
 * @returns {string}
 */
export const getProviderLabel = (item) => {
	const raw = item?.value?.replace(/\s*\(\d+\)\s*$/g, "").trim() || item?.key || "";

	return raw
		.replace(/[_-]/g, " ")
		.replace(/([a-z])([A-Z])/g, "$1 $2")
		.replace(/\b\w/g, (char) => char.toUpperCase());
};

/**
 * @param {string} placeholder
 * @param {{ key?: string, value?: string }} item
 * @returns {string}
 */
export const getProviderTriggerLabel = (placeholder, item) => {
	const providerName = getProviderLabel(item).toLowerCase();
	const baseLabel = placeholder || "Providers";

	return `${baseLabel} (${providerName})`;
};
